import {
    BaseCollectionModel,
    SearchModel,
    yascCreateEntityApiRoutesV3,
    YascEntityApiAdapterV3,
    YascEntityApiRoutesV3,
} from '@yasc/yasc-material-components';
import {
    BaseTaskCreateReq, BaseTaskMinRes,
    BaseTaskRes,
    BaseTaskUpdateReq,
    TaskEffortCreateReq,
    TaskEffortRes,
    TaskEffortUpdateReq
} from '../../../../contracts/v0/crm';
import {ApiV0Crm} from '../api.v0.crm';
import {RestApiService} from '../../../rest-api.service';
import {map, Observable} from "rxjs";

export class ApiV0CrmTaskV3 implements YascEntityApiAdapterV3<BaseTaskMinRes, BaseTaskRes, BaseTaskCreateReq, BaseTaskUpdateReq, string> {

    readonly modelTypes = {
        row: BaseTaskMinRes,
        detail: BaseTaskRes,
        create: BaseTaskCreateReq,
        update: BaseTaskUpdateReq,
    }
    readonly idKey = 'taskID' as const
    readonly segment: string;

    taskEffort: string = ''
    taskReference: string = ''
    readonly routes: YascEntityApiRoutesV3<string>;

    constructor(v0: ApiV0Crm, private readonly rest: RestApiService) {
        this.segment = `${v0.segment}/task`
        this.taskEffort = this.segment + '/effort'
        this.taskReference = this.segment + '/reference'
        this.routes = yascCreateEntityApiRoutesV3<string>(this.segment)
    }

    search(searchModel?: SearchModel): Observable<BaseCollectionModel<BaseTaskRes>> {
        console.log(searchModel)
        return this.rest.post<SearchModel, BaseCollectionModel<BaseTaskRes>>(this.segment + '/search', BaseTaskRes, searchModel);
    }

    detail(id: string): Observable<BaseTaskRes> {
        return this.rest.get<BaseTaskRes>(this.segment + `/${id}`, BaseTaskRes);
    }

    create(request: BaseTaskCreateReq): Observable<BaseTaskRes> {
        return this.rest.post<BaseTaskCreateReq, BaseTaskRes>(`${this.segment}`, BaseTaskRes, request);
    }

    patch(id: string, request: BaseTaskUpdateReq): Observable<BaseTaskRes> {
        return this.rest.patch<BaseTaskUpdateReq, BaseTaskRes>(this.segment + `/${id}`, BaseTaskRes, request);
    }

    delete(ids: string[]): Observable<void> {
        console.log(ids)
        return this.rest.post<string[], unknown>(this.segment + '/bulkDelete',Object as any, ids).pipe(map(() => undefined));
    }

    addEffort(effortCreate: TaskEffortCreateReq) {
        return this.rest.post<TaskEffortCreateReq, TaskEffortRes>(this.taskEffort, TaskEffortRes, effortCreate);
    }

    updateEffort(effortUpdate: TaskEffortUpdateReq) {
        return this.rest.patch<TaskEffortUpdateReq, TaskEffortRes>(this.taskEffort, TaskEffortRes, effortUpdate);
    }

    deleteEffort(ids: string[]) {
        return this.rest.delete<void>(this.taskEffort, {}, ids);
    }
}